export const changeLoginEmailReducer = (state = "", action) => {
  switch (action.type) {
    case "CHANGE_LoginEmail":
      return action.payload.LoginEmail;
    default:
      return state;
  }
};
